<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>
              <span>Error de conexión con el servicio</span>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-alert text color="info" elevation="0" class="ma-5" v-if="!conexionApi">
              Haga click en reintentar para verificar nuevamente si existe conexión.
              <br />Si el problema persiste, comuniquese con el administrador del sistema.
              <v-divider class="my-4 info" style="opacity: 0.22"></v-divider>

              <v-row align="center" no-gutters>
                <v-col class="grow">Perdone las molestias</v-col>
                <v-spacer></v-spacer>
                <v-col class="shrink">
                  <v-btn color="info" outlined @click="reintentar" v-if="!conectandoApi">Reintentar</v-btn>
                </v-col>
              </v-row>
            </v-alert>

            <v-alert text color="success" elevation="0" class="ma-5" v-if="conexionApi">
              Conexión establecida sin problemas.
              <v-divider class="my-4 success" style="opacity: 0.22"></v-divider>

              <v-row align="center" no-gutters>
                <v-col class="grow">Redirigiendo al login...</v-col>
              </v-row>
            </v-alert>
          </v-card-text>

          <v-progress-linear v-if="conectandoApi" :indeterminate="true"></v-progress-linear>
        </v-card>
        <v-snackbar v-model="showError" color="error" :timeout="8000" right>
          {{ mensajeError }}
          <v-btn dark text @click="showError = false">Cerrar</v-btn>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import globalService from "@/services/globalService.js";
import authenticationService from "@/services/authenticationService.js";
import ayuda from "@/components/commons/ayuda";
export default {
  data() {
    return {
      mensajeError: "No se ha logrado establecer comunicación con el servicio.",
      showError: false
    };
  },
  computed: {
    ...mapState("authentication", ["status", "user"]),
    ...mapState("global", ["conexionApi", "conectandoApi"])
  },
  watch: {
    conexionApi: function(val) {
      if (!!val) {
        setTimeout(() => {
          this.$router.push("/login");
        }, 1500);
      }
    }
  },
  components: { ayuda },
  created() {},
  mounted() {
    //si no me estoy conectando a la api y no hay conexión, enviamos a la página de error
    if (!!this.$store.state.global.conexionApi) {
      this.$router.push("/login");
    }
  },
  methods: {
    reintentar: function() {
      this.loadingConexion = true;
      const { commit } = this.$store;

      commit("global/SET_CONECTANDO", true);

      globalService
        .getVersion()
        .then(version => {
          commit("global/SET_CONEXION", true);
          commit("global/SET_VERSION", version);
          this.loadingConexion = false;
          this.errorConexionApi = false;
        })
        .catch(error => {
          commit("global/SET_CONEXION", false);
          this.loadingConexion = false;
          this.showError = true;
        });
    }
  }
};
</script>
